const scrollToResults = () => {
  const list = document.querySelector('.js-events-search-result');
  if (list) {
    const position = list.offsetTop;
    const xCord = 0;
    const interval = 20;
    const offset = 50;
    let i = 0;
    const scroll = setInterval(function () {
      window.scrollTo(xCord, i);
      i += offset;
      if (i >= position) {
        clearInterval(scroll)
      }
    }, interval);
  }
};

export default scrollToResults;
